module.exports = __webpack_public_path__ + "img/THREE.80a8c0bf.png";